// removed by extract-text-webpack-plugin
module.exports = {"button":"LHIR_9_QT9AW8dCjp3jqE"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/Button/Button.css
// module id = 958
// module chunks = 58